import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import * as fromGoods from 'app/store/project/goods/goods.selectors';
import { CartOutput, OrderedGoodOutput, OrderOutput } from 'core/http/project';
import { combineLatest, Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { Uuid } from 'shared/common/types';

type PrettyGood = OrderedGoodOutput & { name$: Observable<string> };
type PrettyCart = CartOutput & { goods: PrettyGood[] };
type PrettyOrder = OrderOutput & { cart: PrettyCart };

@Component({
  selector: 'app-cart',
  templateUrl: './cart.component.html',
  styleUrls: ['./cart.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class CartComponent {
  private _skeletonView = false;
  private _prettyOrder = {} as PrettyOrder;

  get prettyOrder(): PrettyOrder {
    return this._prettyOrder;
  }

  @Input()
  set order(value: OrderOutput) {
    const prettyGoods: PrettyGood[] = value.cart.goods.map((g) => {
      const name$ = this.getGoodName$(g.goodId);

      return { ...g, name$ };
    });

    this._prettyOrder = { ...value, cart: { ...value.cart, goods: prettyGoods } };
  }

  get skeletonView(): boolean {
    return this._skeletonView;
  }

  @Input()
  set skeletonView(value: boolean) {
    this._skeletonView = value;
  }

  constructor(private store$: Store, private translateService: TranslateService) { }

  getGoodName$(id: Uuid): Observable<string> {
    return combineLatest([
      this.store$.select(fromGoods.oneGood, { id }),
      this.translateService.onLangChange.pipe(startWith(null)),
    ])
      .pipe(
        map(([item]) => item ? item.name : this.translateService.instant('COMMON.not_found')),
      );
  }
}
